import React, { FC, useState } from 'react'
import { Button, Table, Input, message, Upload } from 'antd'
import { YhBox } from '@/components/YhBox'
import { ColumnsType } from 'antd/es/table'
import { RouterParamType } from '@/model/navModel'
import { EditableRow, EditableCell, Item } from '@/components/YHEditTable/editTable'
import { ISupplierContacts } from '../../supplierTypes'
import { useSupplierDetailsMode } from './supplierDetailsModel'
import { generateUniqueId } from '@/utils/utils'

export const Contacts: FC<RouterParamType> = ({ id, mode }) => {
    const { editContactsList, addContactsList, setEditContactsList, setAddContactsList } = useSupplierDetailsMode()
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([])

    const handleAddContacts = () => {
        let dataSource = mode === 'edit' ? editContactsList : addContactsList
        dataSource.push({ id: generateUniqueId() })
        mode === 'edit' ? setEditContactsList([...dataSource]) : setAddContactsList([...dataSource])
    }

    const handleRemoveContacts = () => {
        let dataSource = mode === 'edit' ? editContactsList : addContactsList
        if (!selectedRowKeys.length) {
            message.warning('请选择你要删除的联系人')
            return
        }
        mode === 'edit'
            ? setEditContactsList((origin) => origin.filter((item) => selectedRowKeys.indexOf(item.id) < 0))
            : setAddContactsList((origin) => origin.filter((item) => selectedRowKeys.indexOf(item.id) < 0))

        let newSearchData = dataSource.filter((item) => selectedRowKeys.indexOf(item.id) < 0)
        mode === 'edit' ? setEditContactsList([...newSearchData]) : setAddContactsList([...newSearchData])
        setSelectedRowKeys([])
        message.success('删除成功')
    }

    const action = (
        <div>
            <Button className="mr-5" type="link" shape="round" onClick={handleAddContacts}>
                新增联系人
            </Button>
            <Button className="mr-5" type="link" shape="round" onClick={handleRemoveContacts}>
                删除联系人
            </Button>
        </div>
    )

    const columns = [
        {
            title: '序号',
            width: 20,
            align: 'left',
            render: (t: any, r: any, i: number) => i + 1,
        },
        {
            title: '联系人',
            width: 140,
            dataIndex: 'contacts',
            editable: true,
        },
        {
            title: '性别',
            width: 40,
            dataIndex: 'sex',
            editable: true,
            editType: 'select',
            options: [
                { value: '男', label: '男' },
                { value: '女', label: '女' },
            ],
        },
        {
            title: '职务',
            width: 140,
            dataIndex: 'position',
            editable: true,
        },
        {
            title: '联系电话',
            width: 140,
            dataIndex: 'contactNumber',
            editable: true,
            rules: [
                {
                    pattern: /^[1][3-9][0-9]{9}$/,
                    message: '手机号格式不正确!',
                },
            ],
        },
    ]

    const newSelectColumns = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: ISupplierContacts, rowIndex: number) => {
                return {
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col?.rules,
                    options: col?.options,
                    editType: col?.editType,
                    editable: col?.editable,
                    onSelectChange: col?.onSelectChange,
                    onSelectFocus: col?.onSelectFocus,
                    onSelectSearch: col?.onSelectSearch,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleSave,
                }
            },
        }
    })

    //内联编辑
    const handleSave = (row: ISupplierContacts) => {
        console.log(row)
        let dataSource = mode === 'edit' ? editContactsList : addContactsList
        const index = dataSource.findIndex((item) => row.id === item.id)
        const item = dataSource[index]
        dataSource.splice(index, 1, { ...item, ...row })
        mode === 'edit' ? setEditContactsList([...dataSource]) : setAddContactsList([...dataSource])
    }

    return (
        <YhBox title="" action={action}>
            <Table
                rowKey={(record) => record.id}
                rowClassName="editable-row yh-edit-table-tr"
                rowSelection={{
                    selectedRowKeys: selectedRowKeys, //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: ISupplierContacts[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[])
                    },
                }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newSelectColumns as ColumnsType<ISupplierContacts>}
                dataSource={mode === 'edit' ? editContactsList : addContactsList}
                pagination={false}
                scroll={{ x: 'max-content', y: '400px' }}
            />
        </YhBox>
    )
}
